module.exports = __webpack_public_path__ + "static/media/starlink-wall.66a47830.webp";